import { HTTP } from '@/utils/http';
import Apis from '../../apis/index';

const advancedsearch = {
  namespaced: true,
  state: {
    isLoading: false,
    filters: [],
    trackList: [],
    pagination: {
      count: 0,
      pageCount: 0,
      pageSize: 100,
      page: 1
    }
  },
  mutations: {
    updatePagination:(state,  { count,pageCount,pageSize, page }) => state.pagination = { count,pageCount,pageSize, page },
    updateLoadingState :(state, newState) => state.isLoading = newState,
    updateResults(state, results) { state.trackList = results; },
    updateFilters(state, filters) { state.filters = filters; },
    updatePage(state, page) { state.pagination.page = page; },
    updatePageCount(state, pageCount) { state.pagination.pageCount = pageCount;},
    updatePageSize(state, pageSize) { state.pagination.pageSize = pageSize; },
    updateTotal(state, total) { state.pagination.count = total; },
    updateSearchUid(state, uid){ state.searchUid = uid; },
    setPaginationPageSize (state, pageSize) {
        state.pagination.pageSize = pageSize
    },
  },
  actions: {
    setPaginationPageSize ({ commit }, pageSize) {
        commit('setPaginationPageSize', pageSize)
    },

    reset({ commit }) {
      commit('updateSearchUid',null)
      commit('updateResults', [])
      commit('updatePage', 1)
      commit('updateTotal', null)
      commit('updatePageCount', null)
    },

    // async fetch({ commit, state, rootState }, filters) {
    //   // if (state.pagination.pageCount && state.pagination.page > state.pagination.pageCount) {
    //   //   return []
    //   // }

    //   // const params = {
    //   //   filters,
    //   //   searchUid: state.searchUid || '',
    //   //   stationUid: rootState.currentStationUid,
    //   //   sortField: ((filters||[])[0]||{fieldName:'Artist'}).fieldName,
    //   //   sortAscending: true,
    //   //   page: state.pagination.page,
    //   //   pageSize: state.pagination.pageSize,
    //   // };

    //   // try {
    //   //   const { data } = await HTTP.post(Apis.library.tracks.advancedSearch, params)
    //   //   commit('updatePagination', data.dataItem)
    //   //   commit('updateResults', data.dataItem.items)
    //   //   commit('updateSearchUid', data.dataItem.searchUid)
    //   // } catch (error) {
    //   //   console.log(error);
    //   //   commit('updatePageCount', 0) // Get out of loop
    //   //   console.log("Error -> track list ->", error);
    //   // }
    // },

    async launch({ commit, dispatch, state, rootState }, { filters, sortField,sortAscending, page}) {
      commit('updateLoadingState',true);
      // dispatch('reset'); 
      commit('updateFilters', filters)

      const params = {
        filters,
        searchUid: state.searchUid || null,
        stationUid: rootState.currentStationUid,
        sortField: sortField || 'artist',
        sortAscending: sortAscending,
        page: page || 1,
        pageSize: state.pagination.pageSize || 100,
      };
      console.log(params);
       // // const { data } = await HTTP.post(Apis.library.tracks.advancedSearch, params)
       //  HTTP.post(Apis.library.tracks.advancedSearch, params)
       //      .then(data => {
       //        console.log(data);
       //        commit('updatePagination', data.dataItem)
       //        commit('updateResults', data.dataItem.items)
       //        commit('updateSearchUid', data.dataItem.searchUid)
       //      })
       //      .catch(error => {
       //        console.log(error);
       //        commit('updatePageCount', 0) // Get out of loop
       //        console.log("Error -> track list ->", error);
       //      });
      try {
        const { data } = await HTTP.post(Apis.library.tracks.advancedSearch, params)
        commit('updatePagination', data.dataItem)
        commit('updateResults', data.dataItem.items)
        commit('updateSearchUid', data.dataItem.searchUid)
      } catch (error) {
        console.log(error);
        commit('updatePageCount', 0) // Get out of loop
        console.log("Error -> track list ->", error);
      }


      commit('updateLoadingState',false);
    },

    async paginate({ commit, dispatch, state }, { page = null, pageSize = null }) {
      commit('updatePage', page ? page : state.page + 1)
      commit('updatePageSize', pageSize ? pageSize : 100)

      await dispatch('fetch', state.filters)
    }
  },
};

export default advancedsearch;
